import { render, staticRenderFns } from "./ReportProductRecommendation.vue?vue&type=template&id=48506e1d&scoped=true"
import script from "./ReportProductRecommendation.vue?vue&type=script&lang=js"
export * from "./ReportProductRecommendation.vue?vue&type=script&lang=js"
import style0 from "./ReportProductRecommendation.vue?vue&type=style&index=0&id=48506e1d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48506e1d",
  null
  
)

export default component.exports